// Figma: https://www.figma.com/design/nykbXADUTliE6d7xv6FjcQ/NEW-TSAB-Shared-Customer-Library?node-id=2780-30318
// Figma component name: AddOns row (stepper variant — InputStepper)

import classnames from 'classnames'
import NumberStepper from '~/components/ui/NumberStepper'

export default function BoosterField({
  field,
  form: { setFieldValue },
  title,
  info,
  icon,
  price,
  numSeatsMax,
  disabled,
  // eslint-disable-next-line no-unused-vars
  reverseLayout, alternateBackground,
}) {
  const value = field.value || 0
  const max = numSeatsMax ?? 2
  const theme = typeof CONFIG !== 'undefined' && CONFIG.svea_module ? 'svea-taxi' : 'taxi-stockholm'

  return (
    <div className={classnames(
      'flex gap-3 items-center py-3 w-full',
      disabled && 'opacity-[0.38] pointer-events-none',
    )}>
      {/* Icon */}
      {icon && (
        <div className="shrink-0 size-11 overflow-clip flex items-center justify-center">
          <img
            src={`/app/themes/${theme}/static/img/option-icons/${icon}.png`}
            alt=""
            className="size-full object-contain"
          />
        </div>
      )}

      {/* Text column */}
      <div className="flex-1 flex flex-col items-start min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">{title}</span>
        {info && <span className="text-[15px] leading-5 text-on-surface-variant">{info}</span>}
        {price && <span className="text-[15px] font-medium leading-5 text-on-surface-variant">{price}</span>}
      </div>

      <NumberStepper
        value={value}
        min={0}
        max={max}
        onChange={v => setFieldValue(field.name, v)}
      />
    </div>
  )
}
